import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from '../context/AppContext';
import { getMasterDashboardData } from '../services/adminServices';

export const AdminDashboard = () => {

  const { login } = useContext(AppContext)
  const [data, setData] = useState({});
  const getPageData = async () => {
    const result = await getMasterDashboardData(login.token);
    if (result.success) {
      setData(result.data);
    }
  }

  useEffect(() => {
    getPageData();
  }, [])

  return (
    <div className="container my-4">
  <div className="row g-4">

    {/* Total Companies */}
    <div className="col-12 col-md-4">
      <div
        className="card text-center shadow-sm h-100 border-0"
        style={{ background: "#8ec73c", color: "#fff" }}
      >
        <div className="card-body d-flex flex-column justify-content-center">
          <h5 className="card-title fw-semibold mb-2">Total Companies</h5>
          <p className="display-4 fw-bold mb-0">{data.companies}</p>
        </div>
      </div>
    </div>

    {/* Top Companies by Key Count */}
    <div className="col-12 col-md-4">
      <div className="card shadow-sm h-100 border-0">
        <div className="card-body">
          <h5
            className="card-title fw-semibold mb-3"
            style={{ color: "#8ec73c" }}
          >
            Top Companies by Key Count
          </h5>
          <ul className="list-group list-group-flush">
            {data.keyCount?.map((item, idx) => (
              <li
                key={item.companyId}
                className="list-group-item d-flex justify-content-between align-items-center border-0 px-0"
                style={{ background: "transparent" }}
              >
                <span className="fw-medium">
                  {idx + 1}. {item.companyName}
                </span>
                <span
                  className="badge fw-semibold px-3 py-2"
                  style={{
                    background: "#eaf7d4",
                    color: "#8ec73c",
                  }}
                >
                  {item.count}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>

    {/* Key Status Count */}
    <div className="col-12 col-md-4">
      <div className="card shadow-sm h-100 border-0">
        <div className="card-body">
          <h5
            className="card-title fw-semibold mb-3"
            style={{ color: "#8ec73c" }}
          >
            Key Status Summary
          </h5>
          <ul className="list-group list-group-flush">
            {data.keyStatusCount?.map((statusItem) => (
              <li
                key={statusItem.status}
                className="list-group-item d-flex justify-content-between align-items-center border-0 px-0"
                style={{ background: "transparent" }}
              >
                <span className="text-capitalize fw-medium">
                  {statusItem.status}
                </span>
                <span
                  className="badge fw-semibold px-3 py-2"
                  style={{
                    background: "#eaf7d4",
                    color: "#8ec73c",
                  }}
                >
                  {statusItem.count}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

  )
}
